export default __webpack_public_path__ + "v1.18.25/static/media/no-practices.8a6fd274.svg";